import { setConfirmLeaveOrganizationModal } from '../../../../../store/workspace/slice';
import { LeaveMemberIcon, LeaveSquareIcon } from '../../../../../assets/icons';
import { leaveOrganizationThunk } from '../../../../../store/workspace/thunks';
import { useDispatch, useSelector } from '../../../../../store/store';
import { selectUserId } from '../../../../../store/auth/selectors';
import styles from './style.module.scss';
import Modal from '../../../../../components/Modal';
import { useState } from 'react';

export default function ConfirmLeaveOrganization() {
    const dispatch = useDispatch();
    const userId = useSelector(selectUserId);
    const [isLoading, setIsLoading] = useState(false);

    const closeModal = () => dispatch(setConfirmLeaveOrganizationModal(false));

    /** The whole app is re-bootstrapped, the user is no longer a member. */
    const leaveOrganization = () => {
        if (!userId) return;

        setIsLoading(true);
        dispatch(leaveOrganizationThunk({ action: 'leave' }))
            .unwrap()
            .then(() => {
                window.location.reload();
            })
            .catch(() => {
                setIsLoading(false);
            });
    };

    return (
        <Modal
            size='sm'
            actions='both'
            closeFunc={closeModal}
            title='Leave organization'
            icon={<LeaveSquareIcon />}
            childClassName={styles.wrapper}
            dismissButton={{
                text: 'Cancel',
                type: 'Outline-Dark',
                disabled: isLoading,
                onClick: closeModal,
            }}
            confirmButton={{
                text: 'Leave organization',
                type: 'Error',
                loading: isLoading,
                onClick: leaveOrganization,
            }}
        >
            <LeaveMemberIcon />
            <span className={styles.text}>
                Are you sure you want to leave the organization's account membership?
            </span>
        </Modal>
    );
};
